import React from "react";
import { __ } from "services/Translator";
import raceBanner from "assets/play365/images/weekly-race/race-banner-GCC.webp";

// Full-width brand banner for the Weekly Clover Race page: a golden trophy scene
// that greets both prelogin visitors and members at the top of the page.
export default function RaceBanner() {
  return (
    <div className="race-banner">
      <img
        className="race-banner__scene"
        src={raceBanner}
        alt={__("Weekly Clover Race")}
      />
    </div>
  );
}
